"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetFeatureToggle = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file @preserve --api */

/** Enable new favourite-lists landing page replacing favourite-products page", docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11819/Favourite-lists */
const FavouriteLists = '7BBF1CAE-7EEC-440D-AA50-C0953B761DA9';
const useGetFeatureToggle = () => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const staticApiClient = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl,
    tenant,
    language
  });
  const enabled = isUserVerified && !isAnonymousUser;
  const {
    data: {
      data: {
        isEnabled
      }
    } = {
      data: {
        isEnabled: false
      }
    },
    isLoading
  } = (0, _fetching.useSWR)(enabled ? language : null, async () => (0, _staticApiClientReact.getTenantFeatureToggle)(staticApiClient, tenant, FavouriteLists), (0, _presentationUtils.getRetryErrorSwrOptions)());
  return {
    arePersonalListsEnabled: isEnabled,
    isLoadingFeatureToggle: isLoading
  };
};
exports.useGetFeatureToggle = useGetFeatureToggle;
//# sourceMappingURL=useGetFeatureToggle.js.map